<template>
    <div class="flex flex-row justify-end items-center gap-2">
        <v-chip :color="getCompletedColor(item.is_completed)" small dark>
            {{ getIsCompletedText(item.is_completed) }}
        </v-chip>
        <v-tooltip
            v-if="item.status_oferta == 'nu e acceptata' || item.status_oferta == 'contactat' || item.status_oferta == 'in asteptare'"
            right color="black">
            <template v-slot:activator="{ on, attrs }">
                <v-chip :color="getStatusColor(item.status_oferta)" v-bind="attrs" v-on="on" small dark>
                    {{ item.status_oferta }}
                </v-chip>
            </template>
            <span v-if="item.status_oferta == 'nu e acceptata'">{{ item.reject_reason }}</span>
            <span v-else-if="item.status_oferta == 'contactat'">{{ item.contact_type }} - {{
                item.contact_date | formatDate }}</span>
            <span v-else-if="item.status_oferta == 'in asteptare'">{{ item.pending_reason }}</span>
        </v-tooltip>
        <v-chip v-else :color="getStatusColor(item.status_oferta)" small dark>
            {{ item.status_oferta }}
        </v-chip>
        <v-icon color="teal" @click="$emit('changeStatus', item)">
            mdi-sync
        </v-icon>
    </div>
</template>

<script>
export default {
    name: "OfertaStatus",
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    methods: {
        getCompletedColor(isCompleted) {
            return +isCompleted ? 'teal darken-1' : 'blue darken-2'
        },
        getIsCompletedText(isCompleted) {
            return +isCompleted ? "finalizată" : "incompletă";
        },
        getStatusColor(status) {
            if (status == 'noua') return 'red lighten-1'
            else if (status == 'contactat') return 'deep-purple lighten-1'
            else if (status == 'in asteptare') return 'orange darken-1'
            else if (status == 'acceptata') return 'green darken-1'
            else if (status == 'nu e acceptata') return 'grey darken-2'
        }
    }
}
</script>